// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vc-container {\n  font-family: \"Poppins\", sans-serif !important;\n}\n", ""]);
// Exports
module.exports = exports;
